/* import __COLOCATED_TEMPLATE__ from './backup-timing-bib-entry-card.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { inject as service } from '@ember/service';

export default class FinishTimingComponent extends Component 
{
	@service store;
	@service ajax;
	
	@tracked enteredBib = null;

	@action
	async enterBib(browserEvent)
	{
		var event = this.args.event;
		var timingPointId = this.args.timingPointId;
		
		var value = this.enteredBib;
		
		if(value == null || (Number.isNaN(parseInt(value)) && value != '-'))
		{
			alert('invalid bib number');
			this.enteredBib = null;
			return;
		}
		
		let time = new Date().getTime();
		let response = await this.ajax.request("/events/"+event.get('id')+"/intermediateTimingPoint/"+timingPointId+"/enterTime/"+time+"/bib/"+value);
		if(response.error != null)
			alert(response.error);
		
		this.enteredBib = null;
	}
}
